export default __webpack_public_path__ + "static/media/lobby_mock1.bba94775.png";